import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">

      {/* HERO */}
      <section className="contact-hero">
        <h1>CONTACT</h1>
        <p>Reach out. We're here to help you level up.</p>
        <span className="red-line"></span>
      </section>

      {/* CONTACT INFO + MAP */}
      <section className="contact-info-section">

        <div className="contact-left">
          <h2>ACE FITNESS CENTER</h2>

          <div className="info-block">
            <h3>ADDRESS</h3>
            <p>
              ACE Fitness Gym<br />
              12th Floor, Titan Plaza<br />
              Downtown Business District<br />
              Mumbai, India 400001
            </p>
          </div>

          <div className="info-block">
            <h3>CONTACT</h3>
            <p>Phone: +91 9876543210</p>
            <p>WhatsApp: +91 9876543210</p>
            <p>Email: support@acefitness.com</p>
          </div>

          <div className="info-block">
            <h3>WORKING HOURS</h3>
            <p>Mon – Sat: 5:00 AM – 11:00 PM</p>
            <p>Sunday: 6:00 AM – 10:00 PM</p>
          </div>
        </div>

        <div className="contact-right">
          <iframe
            title="ACE Location"
            className="map-frame"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.1160979776!2d72.74109817023423!3d19.082197839746243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c630f3e8b181%3A0xab23cd5e8f9a1791!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1707754330583!5m2!1sen!2sin"
          ></iframe>
        </div>

      </section>

      {/* CTA */}
      <section className="contact-cta">
        <h1>VISIT US. LEVEL UP.</h1>
        <button>Join ACE Today</button>
      </section>

    </div>
  );
};

export default Contact;
